import produce from "immer";
import { IStoreState } from "../initialStoreState";
import { LoadState } from "../../constants/enums";
import { initialAutomobileApplicationState } from "./automobileApplication.types";
import { AutomobileApplicationActions } from ".";
import {
  CLEAR_AUTOMOBILE_APPLICATION_STATE,
  FETCH_AUTAMOBILELL_O_APPLICATION_LIST_FAILED,
  FETCH_AUTOMOBILE_ALBERTA_APPLICATION_FAILED,
  FETCH_AUTOMOBILE_ALBERTA_APPLICATION_PROGRESS,
  FETCH_AUTOMOBILE_ALBERTA_APPLICATION_SUCCESSS,
  FETCH_AUTOMOBILE_ALL_APPLICATION_LIST_PROGRESS,
  FETCH_AUTOMOBILE_APPLICATION_FAILED,
  FETCH_AUTOMOBILE_APPLICATION_LIST_FAILED,
  FETCH_AUTOMOBILE_APPLICATION_LIST_PROGRESS,
  FETCH_AUTOMOBILE_APPLICATION_LIST_SUCCESS,
  FETCH_AUTOMOBILE_APPLICATION_PROGRESS,
  FETCH_AUTOMOBILE_APPLICATION_SUCCESSS,
  FETCH_AUTOMOBILEALL__APPLICATION_LIST_SUCCESS,
} from "./automobileApplicationActions";

export const AutomobileApplicationReducer = (
  state: IStoreState["automobile"]["allApplications"] = initialAutomobileApplicationState,
  action: AutomobileApplicationActions
) => {
  switch (action.type) {
    case FETCH_AUTOMOBILE_ALL_APPLICATION_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.applicationsList.loading = LoadState.InProgress;
        draftState.applicationsList.list = [];
        draftState.applicationsList.totalRecords = 0;
      });
      return newState;
    }
    case FETCH_AUTOMOBILEALL__APPLICATION_LIST_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.applicationsList.loading = LoadState.Loaded;
        draftState.applicationsList.list = data;
      });
      return newState;
    }
    case FETCH_AUTAMOBILELL_O_APPLICATION_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.applicationsList.loading = LoadState.Failed;
        draftState.applicationsList.list = [];
      });
      return newState;
    }

    // Ontario Application

    case FETCH_AUTOMOBILE_APPLICATION_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.application_on.loading = LoadState.InProgress;
        draftState.application_on.application =
          initialAutomobileApplicationState["application_on"]["application"];
      });
      return newState;
    }
    case FETCH_AUTOMOBILE_APPLICATION_SUCCESSS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.application_on.loading = LoadState.Loaded;
        draftState.application_on.application = data;
      });
      return newState;
    }
    case FETCH_AUTOMOBILE_APPLICATION_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.application_on.loading = LoadState.Failed;
        draftState.application_on.application =
          initialAutomobileApplicationState["application_on"]["application"];
      });
      return newState;
    }

    case FETCH_AUTOMOBILE_APPLICATION_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.application_on.listLoading = LoadState.InProgress;
        draftState.application_on.data = [];
      });
      return newState;
    }
    case FETCH_AUTOMOBILE_APPLICATION_LIST_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.application_on.listLoading = LoadState.Loaded;
        draftState.application_on.data = data;
      });
      return newState;
    }
    case FETCH_AUTOMOBILE_APPLICATION_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.application_on.listLoading = LoadState.Failed;
        draftState.application_on.data = [];
      });
      return newState;
    }

    case FETCH_AUTOMOBILE_ALBERTA_APPLICATION_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.application_ab.loading = LoadState.InProgress;
        draftState.application_ab.data =
          initialAutomobileApplicationState["application_ab"]["data"];
      });
      return newState;
    }
    case FETCH_AUTOMOBILE_ALBERTA_APPLICATION_SUCCESSS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.application_ab.loading = LoadState.Loaded;
        draftState.application_ab.data = data;
      });
      return newState;
    }
    case FETCH_AUTOMOBILE_ALBERTA_APPLICATION_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.application_ab.loading = LoadState.Failed;
        draftState.application_ab.data =
          initialAutomobileApplicationState["application_ab"]["data"];
      });
      return newState;
    }

    case CLEAR_AUTOMOBILE_APPLICATION_STATE: {
      return initialAutomobileApplicationState;
    }

    default: {
      return state;
    }
  }
};
